import * as FilterInsightStatus from '../../filterQueryFormat/FilterInsightStatus';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { SuccessIcon, WarningIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
const FilterInsightStatusIcon = props => {
  const {
    filterInsightStatus
  } = props;
  if (filterInsightStatus === FilterInsightStatus.NONE) {
    return /*#__PURE__*/_jsx(IconHolder, {
      icon: WarningIcon,
      color: "fill-caution-default",
      size: "400",
      padding: "0"
    });
  } else if (filterInsightStatus === FilterInsightStatus.SOME) {
    return /*#__PURE__*/_jsx(IconHolder, {
      icon: SuccessIcon,
      color: "fill-positive-default",
      size: "400",
      padding: "0"
    });
  } else {
    return null;
  }
};
export default FilterInsightStatusIcon;